// extracted by mini-css-extract-plugin
module.exports = {"space":"Sample_space__3zRTC","containerImage":"Sample_containerImage__1Xiwg"};